import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frTranslations from './locales/fr.json';
import enTranslations from './locales/en.json';
import ptTranslations from './locales/pt.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frTranslations },
      en: { translation: enTranslations },
      pt: { translation: ptTranslations },
    },
    fallbackLng: 'fr',
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
